import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AreaTypeService {
    private boundaryStatus = new Subject<any>();
    private dataSourceStatus = new Subject<any>();

    constructor() {}

    setBoundaryStatus(message) {
        this.boundaryStatus.next(message);
    }

    getBoundaryStatus(): Observable<any> {
        return this.boundaryStatus.asObservable();
    }

    setDataSourceStatus(message) {
        this.dataSourceStatus.next(message);
    }

    getDataSourceStatus(): Observable<any> {
        return this.dataSourceStatus.asObservable();
    }
}
